import { AppConstants } from "../../../../app.constants";

export class PlaylistInnerItemLinkModel {
  Id: number;
  PlaylistItemLinkId: number;
  ZoomLevel: number;

  constructor(public Link: string = '') {
    this.ZoomLevel = AppConstants.DEFAULT_PLAYLIST_ZOOM_LEVEL;
  }
}
